import { render, staticRenderFns } from "./People.vue?vue&type=template&id=4d3b0f64&"
import script from "./People.js?vue&type=script&lang=js&"
export * from "./People.js?vue&type=script&lang=js&"
import style0 from "./People.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports